<div class="w-full h-full">
    <div class="mx-auto max-w-7xl px-2 lg:px-4 h-full min-h-10">
        <div class="flex h-full overflow-x-auto">
            <div class="flex px-2 lg:px-0 space-x-2 lg:space-x-6 flex-shrink-0">
                @for (item of items; track item.name) {
                    <a
                        [routerLink]="item.href"
                        class="sub-header__item whitespace-nowrap"
                        routerLinkActive="!font-semibold !border-blue-500 !text-gray-900"
                    >
                        {{ item.name }}
                    </a>
                }
            </div>
        </div>
    </div>
</div>
